import gql from 'graphql-tag';

export const setUserStatusMutation = gql`
    mutation setUserStatusMutation($id: ID!, $status: UserStatus!) {
        results: userSetStatus(id: $id, newStatus: $status) {
            id
            status
        }
    }
`;